enum UserPreparerEntryPoints {
  getCollectionActive = '/api/inventory-management/preparer-manager/preparers',
}

export default UserPreparerEntryPoints;
